import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, renderSlot as _renderSlot, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2ddcf040"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "border-radius": "8px"
  }
};
const _hoisted_2 = {
  key: 0,
  id: "button-content"
};
const _hoisted_3 = {
  key: 0,
  class: "selected-value"
};
const _hoisted_4 = ["id"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tooltip-description"
}, " You can assign a Product Segment for every product. These product segments span across marketplaces at a seller level and can be used for filtering and grouping. ", -1));
const _hoisted_6 = {
  class: "p-2 product-search-input-style"
};
const _hoisted_7 = {
  class: "drop-downn-items"
};
const _hoisted_8 = {
  key: 0,
  class: "list-item-container"
};
const _hoisted_9 = {
  class: "list-item-container"
};
const _hoisted_10 = {
  class: "selected-value"
};
const _hoisted_11 = {
  class: "dropdown-content-wrapper"
};
const _hoisted_12 = {
  class: "icon-wrapper"
};
const _hoisted_13 = {
  class: "text-wrapper"
};
const _hoisted_14 = {
  class: "dropdown-item-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_popover = _resolveComponent("b-popover");
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback");
  const _component_b_form_group = _resolveComponent("b-form-group");
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_dropdown, {
    class: "custom-dropdown",
    disabled: $props.disabled,
    variant: "",
    style: {
      "width": "fit-content"
    },
    ref: "dropdown",
    show: $data.isDropdownOpen,
    "auto-close": "outside",
    "no-caret": "",
    boundary: $props.boundary,
    onShow: $options.hideButtonContent,
    onHide: $options.showButtonContent,
    offset: $props.offset
  }, {
    "button-content": _withCtx(() => [!_ctx.$slots['button-content'] ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [!$data.isSearchActive ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$data.computedValue?.text ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($data.computedValue.text), 1)) : (_openBlock(), _createElementBlock("span", {
      key: 1,
      class: "placeholder-content",
      id: `tooltipTarget-${$props.uniqueToolTipID}`
    }, [_createVNode(_component_app_icon, {
      icon: "assign-product-segment",
      class: "placeholder-icon"
    }), _createTextVNode(" " + _toDisplayString($props.placeholder), 1)], 8, _hoisted_4)), !$data.isSearchActive ? (_openBlock(), _createBlock(_component_b_popover, {
      key: 2,
      target: `tooltipTarget-${$props.uniqueToolTipID}`,
      triggers: "hover",
      customClass: "cogs-data-tooltip-class wrap-with-popover"
    }, {
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    }, 8, ["target"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64)) : _renderSlot(_ctx.$slots, "button-content", {
      key: 1
    }, undefined, true)]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_b_form_group, null, {
      default: _withCtx(() => [_createVNode(_component_b_form_input, {
        ref: "searchInput",
        modelValue: $options.sanitizedSearchQuery,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.sanitizedSearchQuery = $event),
        placeholder: "Search...",
        size: "sm",
        onFocus: $options.keepDropdownOpen,
        onBlur: $options.handleInputBlur,
        onKeyup: _withKeys($options.addOption, ["enter"]),
        onKeydown: _withKeys($options.handleInputBlur, ["esc"]),
        class: _normalizeClass({
          'is-invalid': $data.searchQuery && $data.searchQuery.trim().length < 3,
          'custom-input': true
        }),
        style: {
          "width": "255px"
        }
      }, null, 8, ["modelValue", "onFocus", "onBlur", "onKeyup", "onKeydown", "class"]), _createVNode(_component_b_form_invalid_feedback, {
        state: !($data.searchQuery && $data.searchQuery.trim().length < 3)
      }, {
        default: _withCtx(() => [_createTextVNode(" Must be at least 3 characters ")]),
        _: 1
      }, 8, ["state"])]),
      _: 1
    })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_b_dropdown_item, {
      onClick: _cache[1] || (_cache[1] = $event => $options.selectOption('top-item'))
    }, {
      default: _withCtx(() => [_ctx.$slots['top-item'] ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_renderSlot(_ctx.$slots, "top-item", {}, undefined, true)])) : _createCommentVNode("", true)]),
      _: 3
    }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredOptions, (option, index) => {
      return _openBlock(), _createBlock(_component_b_dropdown_item, {
        key: index,
        onClick: $event => $options.selectOption(option),
        class: "dropdown-item custom-dropdown-item"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(option.text), 1)])]),
        _: 2
      }, 1032, ["onClick"]);
    }), 128)), $options.filteredOptions.length === 0 ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
      key: 0,
      disabled: ""
    }, {
      default: _withCtx(() => [_createTextVNode(" No product segment found ")]),
      _: 1
    })) : _createCommentVNode("", true), $data.searchQuery && $props.addMore ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
      key: 1,
      onClick: $options.addOption,
      class: "dropdown-item",
      disabled: $data.searchQuery.trim().length < 2
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_app_icon, {
        icon: "create-product-segment",
        class: "placeholder-icon"
      })]), _createElementVNode("div", _hoisted_13, [_createElementVNode("span", _hoisted_14, "Create \"" + _toDisplayString($data.searchQuery) + "\"", 1)])])]),
      _: 1
    }, 8, ["onClick", "disabled"])) : _createCommentVNode("", true)])]),
    _: 3
  }, 8, ["disabled", "show", "boundary", "onShow", "onHide", "offset"])]);
}